import { Quote, Star, MapPin } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";

const Testimonials = () => {
  return (
    <section className="pt-16 lg:pt-20 pb-24 lg:pb-32 bg-white" data-testid="testimonials-section">
      <div className="container-tm">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="overline">Avis clients</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Ils en parlent
            <span className="italic text-gold"> mieux que nous</span>.
          </h2>
          <p className="mt-6 font-sans text-base md:text-lg text-ink/65 leading-relaxed">
            Côte d'Émeraude, Morbihan : les retours de propriétaires qui nous
            confient leur bien.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name + (t.city || "")}
              data-testid={`testimonial-${i}`}
              className="relative bg-sand border border-gold/20 rounded-2xl shadow-soft hover:shadow-lift transition-shadow duration-500 p-8 lg:p-10 flex flex-col"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-1 text-gold">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} size={14} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <Quote size={28} strokeWidth={1.2} className="text-gold/40" />
              </div>
              <blockquote className="font-serif text-xl md:text-2xl text-ink leading-snug italic mb-8 flex-1">
                "{t.quote}"
              </blockquote>
              <figcaption className="flex items-center gap-4 border-t border-gold/30 pt-6">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-12 h-12 object-cover rounded-full ring-2 ring-gold/30"
                />
                <div>
                  <p className="font-sans text-sm font-semibold text-ink">
                    {t.name}
                  </p>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-sage font-semibold flex items-center gap-1.5 mt-0.5">
                    {t.city ? (
                      <>
                        <MapPin size={11} strokeWidth={2} />
                        Propriétaire à {t.city}
                      </>
                    ) : (
                      "Propriétaire"
                    )}
                  </p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
